import { useRoutes } from "react-router-dom"
import HomePage from "./pages/HomePage"
import HomeLayout from "./layout/HomeLayout"
import ProductPage from "./pages/ProductPage"
import AboutPage from "./pages/AboutPage"
import ServicePage from "./pages/ServicePage"
import ContactPage from "./pages/ContactPage"
import VideoGalleryPage from "./pages/VideoGalleryPage"
import ProductDetailPage from "./pages/ProductDetailPage"
import CSRPage from "./pages/CsrPage"
import CSRDetailPage from "./pages/CsrDetailPage"

export default function Router() {
	let isLoggedIn = !!localStorage.getItem("token")

	let tempRoutes = [
		{
			path: "",
			element: <HomeLayout />,
			children: [
				{ path: "", element: <HomePage /> },
				{ path: "/products", element: <ProductPage /> },
				{ path: "/product/:id", key:'product', element: <ProductDetailPage /> },
				{ path: "/about", element: <AboutPage /> },
				{ path: "/services", element: <ServicePage /> },
				{ path: "/contact", element: <ContactPage /> },
				{ path: "/video-gallery", element: <VideoGalleryPage /> },
				{ path: "/csr", element: <CSRPage /> },
				{ path: "/csr/:id", element: <CSRDetailPage /> }
			]
		}
	]

	const routes = useRoutes(tempRoutes)

	return routes
}
